/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Deserializable } from '@app/shared/models/deserializable.interface';
import * as moment from 'moment';
import { environment } from '@env/environment';

export class DateTime implements Deserializable {
  date: string;

  deserialize(input: any): this {
    this.date = input;
    return this;
  }

  /**
   * Date
   */
  getDate(): string {
    return moment(this.date).format(environment.momentDateFormat);
  }

  /**
   * DateTime
   */
  getDateTime(): string {
    return moment(this.date).format(environment.momentDateTimeFormat);
  }

  /**
   * Time
   */
  getTime(): string {
    return moment(this.date).format('HH:mm:ss');
  }

  getHours(): string {
    return moment(this.date).format('HH');
  }

  getMinutes(): string {
    return moment(this.date).format('mm');
  }

  getSeconds(): string {
    return moment(this.date).format('ss');
  }

  getMilliseconds(): string {
    return moment(this.date).format('x');
  }

  getFullYear(): string {
    return moment(this.date).format('YYYY');
  }

  getMonth(): string {
    return moment(this.date).format('MM');
  }
}
